<template>
  <!-- 创建积分优惠券 -->
  <div class="create_coupons" v-if="isShow">
    <div>
      <header class="head">
        <div @click="retrunMethod()">
          <img src="../../assets/images/integralCenter/header_returnIcon.svg" />
          返回列表
        </div>
        <span class="t">|</span>
        <span class="txt" v-if="tabActive == 10" @change="changeTab(tabActive)">创建积分优惠券</span>
        <span class="txt" v-if="tabActive == 9" @change="changeTab(tabActive)">创建积分兑换实物</span>
      </header>

      <!-- 兑换表单 -->
      <main class="main">
        <span style="color: #fe4d45; line-height: 40px" v-if="tabActive == 9"
          >温馨提示：实物礼品系统帮助收集消费者的邮寄地址，商家自己线下发货，商家承担运费。</span
        >
        <el-form :model="form" :rules="rules" ref="form" label-width="120px">
          <el-form-item label="礼品名称:" v-if="tabActive == 10" required>
            <el-input v-model="form.activityName" maxlength="15" show-word-limit placeholder="积分商城的展示名称" style="width: 320px"></el-input>
          </el-form-item>

          <el-form-item label="礼品名称:" v-if="tabActive == 9" required>
            <el-input v-model="form.activityName" maxlength="15" show-word-limit placeholder="积分商城的展示名称" style="width: 320px"></el-input>
            <el-button type="primary" style="margin-left: 80px" @click="dialogForm">选择本店商品</el-button>
          </el-form-item>

          <el-form-item label="礼品价值:" v-if="tabActive == 9" required>
            <el-input v-model="form.price" @input.native="checkputn1" show-word-limit style="width: 136px"></el-input>&nbsp;元
          </el-form-item>

          <el-form-item label="礼品图片:" v-if="tabActive == 9" required>
            <div></div>
            <el-upload
              ref="upload"
              action="#"
              list-type="picture-card"
              :on-change="handleChange"
              :on-remove="handleRemove"
              :http-request="httpRequest"
            >
              <img v-if="form.wareId && form.logo" :src="form.logo" style="width: 146px; height: 146px" />
              <i class="el-icon-plus" v-else></i>
            </el-upload>
            <!-- <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog> -->
            <span style="color: #fe4d45; font-size: 12px">建议尺寸：750*420像素，图片大小不能超过1.5MB，类型：JPG、PNG</span>
          </el-form-item>

          <el-form-item label="添加优惠券:" v-if="tabActive == 10" required>
            <button class="addBtn" @click.prevent="onShowAddCoupon()" v-if="butActive == 1">
              添加优惠券
            </button>
            <div v-if="butActive == 2 && venderType == false">
              <div class="couponContent">
                <div class="txtNum">
                  ￥
                  <span style="font-size: 36px; color: #fe4d45">{{ couponTxt.discount }}</span>
                </div>
                <div class="txtSize">
                  满 {{ couponTxt.quota }} 元可使用 <br />
                  {{ couponTxt.bindType == 1 ? "店铺券" : "商品券" }}
                </div>
                <p class="time">有效期:{{ couponTxt.beginTime }}~{{ couponTxt.endTime }}</p>
                <div class="background"></div>
                <div class="btn">
                  <el-button @click="createActivity" type="primary" size="small">取消</el-button>
                </div>
              </div>
              <p class="pContent">优惠券名称：{{ couponTxt.name }}</p>
              <p class="pContent">发行量：{{ couponTxt.num }}</p>
              <br />
              <p class="pContent">领券开始时间：{{ couponTxt.tekeBeginTime }}</p>
              <p class="pContent">领券结束时间：{{ couponTxt.takeEndTime }}</p>
              <br />
              <p class="pContent">限领规则：{{ couponTxt.takeRule == 5 ? "活动期间限领一张" : "每天限领一张" }}</p>
            </div>

            <div v-if="butActive == 2 && venderType == true">
              <div class="couponContent">
                <div class="txtNum">
                  ￥
                  <span style="font-size: 36px; color: #fe4d45">{{ couponTxt.discount }}</span>
                </div>
                <div class="txtSize">
                  满 {{ couponTxt.quota }} 元可使用 <br />
                  {{ couponTxt.bindType == 1 ? "店铺券" : "商品券" }}
                </div>
                <p class="time">有效期:{{ couponTxt.startTime }}~{{ couponTxt.endTime }}</p>
                <div class="background"></div>
                <div class="btn">
                  <el-button @click="butActive = 1" type="primary" size="small">取消</el-button>
                </div>
              </div>
              <p class="pContent">优惠券名称：{{ couponTxt.name }}</p>
              <p class="pContent">发行量：{{ couponTxt.issuedQuantity }}</p>
              <br />
              <p class="pContent">领券开始时间：{{ couponTxt.takeBeginTime }}</p>
              <p class="pContent">领券结束时间：{{ couponTxt.takeEndTime }}</p>
              <br />
              <p class="pContent">限领规则：{{ couponTxt.takeRule == 5 ? "活动期间限领一张" : "每天限领一张" }}</p>
            </div>
          </el-form-item>

          <el-form-item label="每人限兑次数:">
            <div class="limitBox">
              <el-input v-model="form.exchangeTimes" @input.native="checkputn0" style="width: 136px"></el-input>&nbsp;次
              <p class="desc">
                <img
                  src="@/assets/images/new_icon_reminder1.png"
                  style="
                    display: inline-block;
                    float: left;
                    width: 14px;
                    height: 14px;
                    color: #ffffff;
                    margin: 9px 4px 0 3px;
                  "
                />
                不填则默认不限
              </p>
            </div>
          </el-form-item>
          <!-- required -->
          <el-form-item label="总份数:" v-if="tabActive == 9" required>
            <el-input v-model="form.quantityTotal" @input.native="checkputn1" style="width: 136px"></el-input>
          </el-form-item>

          <el-form-item label="上下架时间:" required>
            <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.startTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 135px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :clearable="false"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.endTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 150px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                :clearable="false"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTime()"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
            </div>
            <span class="lastTime">
              活动持续
              <span style="color: #fe4d45">{{ timeDay }}</span> 天 <span style="color: #fe4d45">{{ timeOut }}</span> 小时

              <!-- <span style="color: #FE4D45;">23</span> 小时  -->
            </span>
          </el-form-item>

          <el-form-item label="兑换所需等级:" required>
            <el-checkbox-group v-model="memberLe" @change="checkListchange" style="float: left; min-width: 100px">
              <el-checkbox :label="memberLe">全部</el-checkbox>
            </el-checkbox-group>
            <el-checkbox-group
              v-model="level"
              v-for="(item, index) in memberLevelList"
              :key="index"
              @change="checkTheChange"
              style="float: left; min-width: 100px"
            >
              <el-checkbox :label="item.label" :disabled="memberLe == true" v-if="item.value">{{ item.value }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="兑换所需积分:" required>
            <div class="isLevelSet" style="width: 600px">
              <template v-if="!isLevelSet">
                <el-input v-model.number="form.memberLevelPoints" @input.native="checkputn1" style="width: 136px; margin-right: 20px"></el-input>
              </template>
              <template v-else>
                <!-- <ul
                  v-if="memberLe == true"
                  class="levelList"
                  v-for="(item, index) in memberLevelList"
                  :key="index"
                >
                  <li class="item" style="width: 180px" v-if="item.label != -1">
                    {{ item.value }}
                    <el-input
                      v-if="item.label != -1"
                      v-model.number="item.point"
                      placeholder="请输入..."
                      @input.native="checkputn1"
                      style="width: 80px"
                    ></el-input>
                    积分
                  </li>
                  <br />
                </ul>  -->
                <ul class="levelList">
                  <li class="item" style="width: 180px" v-if="level.includes(0)">
                    {{ memberLevelList[0].value }}
                    <el-input
                      v-model.number="memberLevelList[0].point"
                      placeholder="请输入..."
                      @input.native="checkputn1"
                      style="width: 80px"
                    ></el-input>
                    积分
                  </li>
                  <br />
                  <li class="item" style="width: 180px" v-if="level.includes(1)">
                    {{ memberLevelList[1].value }}
                    <el-input
                      v-model.number="memberLevelList[1].point"
                      placeholder="请输入..."
                      @input.native="checkputn1"
                      style="width: 80px"
                    ></el-input>
                    积分
                  </li>
                  <br />
                  <li class="item" style="width: 180px" v-if="level.includes(2)">
                    {{ memberLevelList[2].value }}
                    <el-input
                      v-model.number="memberLevelList[2].point"
                      placeholder="请输入..."
                      @input.native="checkputn1"
                      style="width: 80px"
                    ></el-input>
                    积分
                  </li>
                  <br />
                  <li class="item" style="width: 180px" v-if="level.includes(3)">
                    {{ memberLevelList[3].value }}
                    <el-input
                      v-model.number="memberLevelList[3].point"
                      placeholder="请输入..."
                      @input.native="checkputn1"
                      style="width: 80px"
                    ></el-input>
                    积分
                  </li>
                  <br />
                  <li class="item" style="width: 180px" v-if="level.includes(4)">
                    {{ memberLevelList[4].value }}
                    <el-input
                      v-model.number="memberLevelList[4].point"
                      placeholder="请输入..."
                      @input.native="checkputn1"
                      style="width: 80px"
                    ></el-input>
                    积分
                  </li>
                  <br />
                  <li class="item" style="width: 180px" v-if="level.includes(5)">
                    {{ memberLevelList[5].value }}
                    <el-input
                      v-model.number="memberLevelList[5].point"
                      placeholder="请输入..."
                      @input.native="checkputn1"
                      style="width: 80px"
                    ></el-input>
                    积分
                  </li>
                  <br />
                </ul>
              </template>
              <button class="setBtn" @click.prevent="isLevel">
                {{ isLevelSet == false ? "按会员等级设置" : "统一设置" }}
              </button>
            </div>
          </el-form-item>

          <el-form-item label="规则说明:" required>
            <div
              style="
                width: 720px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding-top: 8px;
              "
            >
              <el-input type="textarea" class="textarea" style="width: 704px" resize="none" :rows="6" v-model="form.ruleDescription"></el-input>

              <div style="margintop: 8px">
                <el-button type="primary" class="generate" plain @click="generativerule">生成规则</el-button>
                <span class="txt">点击按钮自动生成规则，也可以自己编辑信息</span>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </main>

      <!-- 底部按钮 -->
      <footer class="foot">
        <button class="backBtn" @click="retrunMethod()">返回上一页</button>
        <button class="keepBtn" @click="setActivity" v-preventReClick>
          保存并完成设置
        </button>
      </footer>

      <!-- 添加优惠券 -->
      <add-coupon :isShow="addCouponIsShow" @close="addCouponIsShow = false" @funcMes="addStatus"></add-coupon>

      <!-- 自营=====添加优惠券 -->
      <self-support-addCoupon
        :isShow="selfSupportAddCouponIsShow"
        @close="selfSupportAddCouponIsShow = false"
        @funcMes="addStatusCoupon"
      ></self-support-addCoupon>
    </div>
    <!-- 选择商品弹窗 -->
    <el-dialog title="选择商品" :visible.sync="dialogFormVisible" width="820px">
      <input-form style="margin: 20px 0" :inputData="commodityList" @toParentVal="searchContent"></input-form>
      <el-table
        :data="tableShopData"
        stripe
        style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column width="100">
          <template slot-scope="scope">
            <img :src="scope.row.logo" class="avar" alt="商品图片" style="height: 60px; width: 60px" />
          </template>
        </el-table-column>
        <el-table-column prop="skuName" label="商品名称" width="300">
          <template slot-scope="scope">
            <a :href="scope.row.itemUrl" target="_blank"
              >{{ scope.row.skuName }}<br />
              ¥{{ scope.row.jdPrice }}</a
            >
          </template>
        </el-table-column>
        <el-table-column prop="skuId" label="SKU ID" width="200"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="chooseShop(scope.row)" style="width: 50px">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin: 40px 80px 0 0; text-align: right"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 30, 50, 100]"
        :page-size="5"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="totalList"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import addCoupon from "./add_coupon";
import selfSupportAddCoupon from "./selfSupport_add_coupon"; //自营
import inputForm from "../../components/inputForm";
import { querydetail, closeSellerCouponWrite } from "@/api/integralCenter/couponWriteController.js";

import { getTaobaoItemListSku, getSellercats } from "@/api/analysis/ware-controller.js";
import { getTaobaoItemList } from "@/api/public1";
import { setActivityList, uploadpic, setActivityVenderType } from "@/api/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import { mapState } from "vuex";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    tabActive: {
      type: Number,
      default: 10,
    },
  },
  components: {
    addCoupon,
    inputForm,
    selfSupportAddCoupon,
  },
  computed: {
    ...mapState(["venderType"]),
  },

  data() {
    return {
      fileList: [],
      memberLevelPointsDTOList: [
        // {
        //   level:1,
        //   allow:true,
        //   point:10
        // }
      ],
      butActive: 1,
      commodityList: [
        // {
        //   name: "商品类目:",
        //   val: "categoryId",
        //   selectArr: [],
        //   width: 240,
        // },
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          multiple: true,
          width: 240,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID",
          width: 240,
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
          width: 240,
        },
        {
          name: "商品状态:",
          val: "skuStatus",
          default: 1,
          selectArr: [
            { label: "全部", id: null },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 136,
        },
      ],
      // 表单值
      form: {
        logo: "",
        activityName: "",
        ruleDescription: "",
        price: null,
        exchangeTimes: null,
        quantityTotal: null,
        startTime: "",
        endTime: "",
        memberLevelPoints: "",
        couponRedemptionType: "",
      },
      level: [0, 1, 2, 3, 4, 5],
      memberLevelList: [
        // { value: "全部", label: -1, point: "", levelName: "全部" },
        { value: "非会员", label: 0, point: "", levelName: "非会员" },
        { value: "一星会员", label: 1, point: "", levelName: "一星会员" },
        { value: "二星会员", label: 2, point: "", levelName: "二星会员" },
        { value: "三星会员", label: 3, point: "", levelName: "三星会员" },
        { value: "四星会员", label: 4, point: "", levelName: "四星会员" },
        { value: "五星会员", label: 5, point: "", levelName: "五星会员" },
      ],
      memberLevelListchange: [],
      // 表单校验
      rules: {
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        quantityTotal: {
          required: true,
          message: "请输入总份数",
          trigger: "blur",
        },
      },
      startTime: null,
      endTime: null,
      isLevelSet: false,
      islabled: false,
      dialogFormVisible: false,
      // 添加优惠券显示隐藏状态控制
      addCouponIsShow: false,
      selfSupportAddCouponIsShow: false,

      //上传图片
      dialogImageUrl: "",
      dialogVisible: false,
      tableShopData: [],
      couponTxt: {},
      totalList: 0,
      currentPage: 1,
      couponId: 0,
      formShopList: { current: 1, size: 5, skuStatus: 1 },
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      memberLe: true,
      spliceData: 0,
    };
  },
  mounted() {
    console.log("this.venderType", this.venderType);
    this.getLevel();
  },
  methods: {
    onShowAddCoupon() {
      if (this.venderType == true) {
        this.selfSupportAddCouponIsShow = true;
      } else {
        this.addCouponIsShow = true;
      }
    },
    isLevel() {
      let val = this.level;
      let i,
        j,
        t = 0;
      for (i = 0; i < val.length; i++) {
        for (j = 0; j < val.length; j++) {
          if (val[i] < val[j]) {
            t = val[i];
            val[i] = val[j];
            val[j] = t;
          }
        }
      }
      if (this.isLevelSet == true) {
        this.memberLevelListchange = [];
      } else if (this.isLevelSet == false) {
        for (let i = 0; i < val.length; i++) {
          for (let j = 0; j < this.memberLevelList.length; j++) {
            if (val[i] == this.memberLevelList[j].label) {
              this.memberLevelListchange.push(this.memberLevelList[j]);
            } else {
              continue;
            }
          }
        }
        this.level.splice(this.spliceData, 5);
      }
      this.isLevelSet = !this.isLevelSet;
      this.form.memberLevelPoints = "";
      this.memberLevelList.forEach((item) => {
        item.point = "";
      });
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          if (res.data[0]) {
            this.memberLevelList[1].value = res.data[0].customerLevelName;
          } else {
            this.memberLevelList[1].value = "";
          }
          if (res.data[1]) {
            this.memberLevelList[2].value = res.data[1].customerLevelName;
          } else {
            this.memberLevelList[2].value = "";
          }
          if (res.data[2]) {
            this.memberLevelList[3].value = res.data[2].customerLevelName;
          } else {
            this.memberLevelList[3].value = "";
          }
          if (res.data[3]) {
            this.memberLevelList[4].value = res.data[3].customerLevelName;
          } else {
            this.memberLevelList[4].value = "";
          }
          if (res.data[4]) {
            this.memberLevelList[5].value = res.data[4].customerLevelName;
          } else {
            this.memberLevelList[5].value = "";
          }
          (this.spliceData = res.data.length + 1), this.level.splice(this.spliceData, 5);
        })
        .catch((res) => {});
    },
    //输入框限制负数
    checkputn0(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value <= 0) {
        this.$message({
          message: "请填写大于0的数字",
          type: "warning",
        });
        e.target.value = "";
      }
    },
    //输入框限制负数
    checkputn1(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    //返回
    retrunMethod() {
      this.form.activityName = "";
      this.form.logo = "";
      this.form.activityName = "";
      this.form.ruleDescription = "";
      this.form.price = null;
      this.form.exchangeTimes = null;
      this.form.quantityTotal = null;
      this.form.startTime = "";
      this.form.endTime = "";
      this.level = [0, 1, 2, 3, 4, 5];
      this.memberLe = true;
      this.form.memberLevelPoints = "";
      this.form.couponRedemptionType = ""; //v3.9新增
      this.$emit("return");
    },
    //活动时间驱动
    activityTimeChange(val) {
      let nowTime = new Date().getTime();
      let start = new Date(this.form.startTime).valueOf();
      let end = new Date(this.form.endTime).valueOf();
      let invalidateDate = new Date(this.$store.getters.pointUserInfo.expiredIn).valueOf();
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.form.endTime = null;
        return;
      }
      if (start < nowTime) {
        this.$message.warning("开始时间不能小于当前时间");
        // this.form.startTime = null;
        // return;
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.form.endTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        this.form.endTime = null;
        return;
      }

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.form.startTime.substring(0, 10);
      daysEnd = this.form.endTime.substring(0, 10);
      if (this.form.endTime != "" && this.form.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 = new Date(this.form.endTime).getTime() - new Date(this.form.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
    },
    // 隐藏添加优惠券组件
    addCouponChange() {
      this.addCouponIsShow = false;
      // console.log(111);
    },
    //取消优惠券
    createActivity() {
      let couponId = this.couponId;
      closeSellerCouponWrite(couponId)
        .then((res) => {
          if (res && res.code == 1) {
            this.butActive = 1;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      // console.log(val);

      if (val == true) {
        this.level = [0, 1, 2, 3, 4, 5];
      } else {
        this.level = [];
      }
      this.level.splice(this.spliceData, 5);
    },

    checkTheChange(val) {
      if (val.length == 6) {
        this.memberLe = true;
      } else {
        this.memberLe = false;
      }
    },

    //获取优惠券信息
    addStatus(val) {
      this.butActive = 2;
      this.couponId = Number(val);
      querydetail(this.couponId)
        .then((res) => {
          this.couponTxt = res.data;
          let sum1 = res.data.beginTime.split(" ");
          let sum2 = res.data.endTime.split(" ");
          this.couponTxt.beginTime = sum1[0];
          this.couponTxt.endTime = sum2[0];
          // console.log(res);
        })
        .catch((res) => {});
    },

    //自营店铺获取优惠券信息
    addStatusCoupon(data) {
      console.log("data", data);
      this.butActive = 2;
      this.couponTxt = data;
      let sum1 = data.startTime.split(" ");
      let sum2 = data.endTime.split(" ");
      this.couponTxt.startTime = sum1[0];
      this.couponTxt.endTime = sum2[0];
    },

    dialogForm() {
      this.dialogFormVisible = true;
      this.getShopList();
      this.getSeller();
    },
    //获取店铺商品
    getShopList() {
      let params = {
        approveStatus: "",
        categoryType: 1,
        cid: "",
        endPrice: "",
        itemTitle: "",
        numIid: "",
        pageNum: 1,
        pageSize: 10,
        pid: "",
        startPrice: "",
      };
      getTaobaoItemList(params).then((res) => {
        console.log(res, 99999);
        this.tableShopData = res.data.dataList.map((item) => {
          return {
            ...item,
            logo: item.picUrl,
            discount: item.price,
            wareId: item.numIid,
            skuId: item.numIid,
            skuName: item.itemTitle,
            jdPrice: item.price,
          };
        });
        this.totalListThr = Number(res.data.pageInfo.total);
      });

      // getTaobaoItemListSku(this.formShopList).then((res) => {
      //   this.tableShopData = res.data.records;
      //   this.totalList = res.data.total;
      // });
    },
    // 获取商品类目
    getSeller() {
      getSellercats().then((res) => {
        let data = this.transverter(res.data);
        // console.log(data);
        this.getTrees(data);
        // console.log(data);
        // debugger
        let list = data.filter((item) => item.parent_id == 0);
        // console.log('list',list);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        console.dir(cascaderArr);

        this.commodityList[0].cascaderArr = cascaderArr;
      });
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },

    //选择
    chooseShop(val) {
      console.log(val);
      this.form.activityName = val.skuName.substr(0, 15);
      this.form.price = val.jdPrice;
      this.form.wareId = val.categoryId;
      this.form.logo = val.logo;
      this.dialogFormVisible = false;
    },
    searchContent(val) {
      // console.log(val, 2222);
      this.formShopList.size = 5;
      this.formShopList.current = 1;
      // this.formShopList.cascaderArr = val.cascaderArr;
      if (val.categoryId) {
        this.formShopList.categoryId = val.categoryId.join(",");
      } else {
        this.formShopList.categoryId = "";
      }
      this.formShopList.skuId = val.skuId;
      this.formShopList.skuStatus = val.skuStatus;
      this.formShopList.skuName = val.skuName;
      this.getShopList();
    },

    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 1024 * 1.5;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 1.5MB");
        this.$refs.upload.clearFiles();
      } else {
        this.fileList = fileList;
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.form.logo = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    httpRequest() {},
    // 生成规则
    generativerule() {
      //活动规则判断
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "";
      //活动名称
      if (this.form.activityName.length > 0) {
        text1 = "礼品名称：" + this.form.activityName;
      }
      if (this.form.price) {
        text2 = "礼品价值" + this.form.price + "元";
      }
      if (this.form.exchangeTimes) {
        text3 = "每人限兑次数：" + this.form.exchangeTimes + "次";
      } else {
        text3 = "每人限兑次数：不限次数";
      }
      if (this.form.quantityTotal) {
        text4 = "总份数：" + this.form.quantityTotal;
      }
      if (this.form.startTime && this.form.endTime) {
        text5 = "上下架时间：" + this.form.startTime + "至" + this.form.endTime;
      }
      if (this.form.memberLevelPoints == "") {
        if (this.form.memberLevelPoints == "" && this.isLevelSet == false) {
          this.$message({
            message: "请填写兑换所需积分",
            type: "warning",
          });
        } else {
          if (this.level.length > 0) {
            let levelText = [];
            this.level.forEach((item, index) => {
              if (item == -1) {
                item = "全部";
              } else {
                this.memberLevelList.forEach((it, index) => {
                  if (item == index) {
                    item = it.value + ":" + it.point + "积分";
                  }
                });
              }
              levelText.push(item);
            });
            text6 = "兑换所需等级及积分:" + levelText.splice(",");
          }
        }
      } else {
        if (this.level.length > 0) {
          let levelText = [];
          this.level.forEach((item, index) => {
            if (item == -1) {
              item = "全部";
            } else {
              this.memberLevelList.forEach((it, index) => {
                if (item == index) {
                  item = it.value + ":" + this.form.memberLevelPoints + "积分";
                }
              });
            }
            levelText.push(item);
          });
          text6 = "兑换所需等级及积分:" + levelText.splice(",");
        }
      }
      let Arr1 = [text1, text2, text3, text4, text5, text6, text7, text8];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + "。" + "\n";
          newNum = newNum + 1;
        }
      });
      this.form.ruleDescription = newText;
    },

    clearTime() {
      this.form.startTime = "";
      this.form.endTime = "";
    },

    //创建礼品兑换活动
    setActivity() {
      //活动创建限制
      if (!this.form.activityName) {
        this.$message.warning("请输入礼品名称");
        return;
      }
      if (this.butActive == 1 && this.tabActive == 10) {
        this.$message.warning("请添加优惠券");
        return;
      }
      if (!this.form.price && this.tabActive == 9) {
        this.$message.warning("请输入礼品价值");
        return;
      }
      if (!this.form.logo && this.tabActive == 9) {
        this.$message.warning("请添加礼品图片");
        return;
      }
      if (!this.form.startTime || !this.form.endTime) {
        this.$message.warning("请输入上下架时间");
        return;
      }
      if (this.level.length == 0) {
        this.$message.warning("请输入兑换所需等级");
        return;
      }
      if (!this.form.quantityTotal && this.tabActive == 9) {
        this.$message.warning("请输入总份数!");
        return;
      }
      if (!this.form.memberLevelPoints && this.isLevelSet == false) {
        this.$message.warning("请输入兑换所需积分");
        return;
      }
      if (!this.form.ruleDescription) {
        this.$message.warning("请输入规则说明");
        return;
      }
      let obj = {
        activityName: "",
        activityType: 9,
        couponId: 0,
        endTime: "",
        exchangeTimes: -1,
        giftType: 0,
        logo: "",
        memberLevelPointsDTOList: [],
        price: 0,
        quantityTotal: 0,
        ruleDescription: "",
        startTime: "",
        title: "",
        wareId: 0,
      };
      let bbb = [false, false, false, false, false, false];
      //  console.log(this.form.memberLevelPointsDTOList.level,2222);
      let ccc = [];
      if (this.level == -1) {
        ccc = [0, 1, 2, 3, 4, 5];
        console.log(ccc);
      } else {
        ccc = this.level;
        console.log(ccc);
      }
      // let ccc = this.level;
      // return;
      ccc.forEach((item) => {
        bbb[item] = true;
      });

      this.memberLevelPointsDTOList = [];
      this.memberLevelList.forEach((item, index) => {
        if (item.label == -1) {
          return;
        } else {
          let hhhh = {};
          if (this.isLevelSet == true) {
            hhhh.point = Number(this.memberLevelList[index].point);
          } else {
            hhhh.point = this.form.memberLevelPoints;
          }
          hhhh.level = this.memberLevelList[index].label;

          hhhh.allow = bbb[index];

          this.memberLevelPointsDTOList.push(hhhh);
        }
        // console.log(item);
      });
      obj = this.form;
      obj.memberLevelPointsDTOList = this.memberLevelPointsDTOList;
      console.log(obj, "obj");
      if (this.couponTxt.discount != null) {
        obj.price = Number(this.couponTxt.discount);
      } else {
        obj.price = this.form.price;
        obj.title = this.form.activityName;
        obj.wareId = this.form.wareId;
        if (this.form.wareId != null) {
          obj.giftType = 1;
        } else {
          obj.giftType = 2;
        }
      }
      obj.activityName = this.form.activityName;
      obj.activityType = this.tabActive;
      obj.couponId = this.couponId;
      if (this.form.exchangeTimes != null) {
        obj.exchangeTimes = Number(this.form.exchangeTimes);
      }
      if (this.form.quantityTotal) {
        obj.quantityTotal = Number(this.form.quantityTotal);
      }
      // form.quantityTotal
      console.log(obj, "aaaa");
      // return;

      if (this.venderType) {
        // debugger
        obj.safeCoupon = this.couponTxt;
        // obj.quantityTotal = obj.safeCoupon.issuedQuantity;
        obj.takeRule = obj.safeCoupon.limitRule;
        obj.quantityTotal = Number(this.form.quantityTotal);
        // obj.safeCoupon.startTime = "2022-01-25"
        // obj.safeCoupon.takeBeginTime = "2022-01-26"
        // obj.safeCoupon.endTime = "2022-02-25"
        // obj.safeCoupon.takeEndTime = "2022-02-24"

        setActivityVenderType(obj).then((res) => {
          if (res && res.code == 1) {
            this.memberLevelPointsDTOList = [];
            this.$message.success(res.message);
            let routeUrl = this.$router.resolve({
              path: "/integralCenter/integralMall",
              query: { tabAct: 3 },
            });
            window.open(routeUrl.href, "_self");
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        setActivityList(obj)
          .then((res) => {
            if (res && res.code == 1) {
              this.memberLevelPointsDTOList = [];
              this.$message.success(res.message);
              let routeUrl = this.$router.resolve({
                path: "/integralCenter/integralMall",
                query: { tabAct: 3 },
              });
              window.open(routeUrl.href, "_self");
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      }
    },
    //分页事件
    handleSizeChange(val) {
      this.formShopList.size = val;
      this.getShopList();
    },
    handleCurrentChange(val) {
      fn;
      this.formShopList.current = val;
      this.getShopList();
    },
  },
};
</script>

<style scoped lang="scss">
.create_coupons {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 880px;
  .head {
    flex-shrink: 0;
    box-sizing: border-box;
    padding-left: 24px;
    height: 50px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f6f6f6;
    font-size: 14px;
    div {
      display: flex;
      align-items: center;
      color: #999;
      cursor: pointer;
      img {
        margin-right: 4px;
      }
    }
    .t {
      margin: 0 20px;
      color: #ccc;
    }
    .txt {
      color: #333;
    }
  }
  .main {
    flex: 1;
    box-sizing: border-box;
    padding: 40px 0 0 70px;
    .addBtn {
      width: 98px !important;
      height: 32px;
      line-height: 28px;
      border: 1px solid #fe4d45;
      color: #fe4d45;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
    .couponContent {
      height: 130px;
      width: 260px;
      border: 1px solid #dddddd;
      border-radius: 10px;
      position: relative;
      .txtNum {
        position: absolute;
        margin: 25px;
        width: 160px;
      }
      .txtSize {
        margin: 20px 0 0 140px;
        line-height: 22px;
      }
      .time {
        font-size: 12px;
        margin-left: 30px;
        color: #999999;
      }
      .btn {
        display: none;
        opacity: 0;
      }
      &:hover {
        box-shadow: 0px 0px 8px 2px #dddddd;
        .btn {
          display: inline;
          margin: -17px 0 0 -49px;
          opacity: 1;
          position: absolute;
          left: 50%;
          top: 50%;
        }
        .background {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 10px;
          background-color: #fff;
          opacity: 0.7;
        }
      }
    }
    .pContent {
      // display: block;
      float: left;
      width: 250px;
      color: #999999;
    }
    .limitBox {
      display: flex;
      align-items: center;
      .desc {
        margin-left: 32px;
        font-size: 13px;
        color: #999;
        i {
          color: #fe8f8a;
          opacity: 0.8;
        }
      }
    }
    .lastTime {
      color: #333;
    }
    .isLevelSet {
      // display: flex;
      .levelList {
        display: flex;
        flex-wrap: wrap;
        width: 200px;
        float: left;
        .item {
          // width: 50%;
          text-align: right;
          margin-bottom: 16px;
          font-size: 14px;
          color: #333;
        }
      }
      .setBtn {
        width: 115px;
        height: 32px;
        line-height: 28px;
        // margin-left: 20px;
        border: 1px solid #fe4d45;
        color: #fe4d45;
        background-color: #fff4f4;
        font-size: 13px;
        &:hover {
          background-color: #fe4d45;
          color: #fff;
        }
      }
    }
    .generate {
      border: 1px solid #7f85e9;
      background: rgba(127, 133, 233, 0.1);
      color: #7f85e9;
      width: 76px;
      height: 28px;
      line-height: 24px;
    }
    .txt {
      margin-left: 12px;
      color: #999;
      font-size: 13px;
    }
  }
  .foot {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    // width: 100%;
    // position: absolute;
    bottom: -150px;
    justify-content: flex-start;
    height: 80px;
    border-top: 1px solid #f6f6f6;
    margin-left: 88px;
    .backBtn {
      width: 148px;
      margin-right: 20px;
      border: 1px solid #fe4d45;
      color: #fe4d45;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
    .keepBtn {
      width: 188px;
      background-color: #fe4d45;
      color: #fff;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  p {
    margin: 0;
  }
  button {
    height: 34px;
    line-height: 32px;
    text-align: center;
    // border: none;
    // background-color: white;
    outline: none;
    cursor: pointer;
    border-radius: 3px;
    transition: all 0.2s;
  }
}
</style>
